export const tableHeader = [
	'billingHistoryModal.product',
	'billingHistoryModal.date',
	'billingHistoryModal.amount',
	'billingHistoryModal.status',
	'billingHistoryModal.download',
];

export const formatDate = (dateString: string) => {
	const date = new Date(dateString);
	const year = date.getFullYear();
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const day = date.getDate().toString().padStart(2, '0');
	return `${year}-${month}-${day}`;
};
